module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/text-97928eee8ab14c89a8a9a8d6e582815e.svg";